// =============================================
// UTILITY HELPERS
// =============================================

/** Safely query an element — returns null if not found */
function qs(sel, root) { return (root || document).querySelector(sel); }
function qsa(sel, root) { return (root || document).querySelectorAll(sel); }

// =============================================
// STICKY HEADER — shadow on scroll
// =============================================
const header = qs('.header');
if (header) {
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        header.classList.toggle('scrolled', window.scrollY > 50);
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
}

// =============================================
// SCROLL REVEAL — IntersectionObserver
// =============================================
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

qsa('.reveal').forEach(el => revealObserver.observe(el));

// =============================================
// FAQ ACCORDION
// =============================================
qsa('.faq-item__q').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    if (!item) return;
    const wasOpen = item.classList.contains('open');
    qsa('.faq-item').forEach(i => i.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
  });
});

// =============================================
// SMOOTH SCROLL — anchor links
// =============================================
qsa('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const href = this.getAttribute('href');
    if (!href || href === '#') return;
    const target = qs(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// =============================================
// HERO — Variant radio selection (replaces inline onchange)
// =============================================
qsa('.hero__variant-radio').forEach(radio => {
  radio.addEventListener('change', (e) => {
    const targetId = e.target.dataset.variantTarget;
    if (!targetId) return;
    const hidden = document.getElementById(targetId);
    if (hidden) hidden.value = e.target.value;
    // Update active visual state
    const container = e.target.closest('.hero__variants');
    if (container) {
      container.querySelectorAll('.hero__variant-option').forEach(opt => {
        opt.classList.toggle('hero__variant-option--active', opt.querySelector('input:checked'));
      });
    }
    // Swap hero image if variant has an image
    const mainImg = qs('#hero-main-img');
    if (mainImg && e.target.dataset.imgSrc) {
      mainImg.src = e.target.dataset.imgSrc;
    }
  });
});

// =============================================
// STICKY ATC BAR — shows when hero CTA scrolls out
// =============================================
const stickyBar = qs('.sticky-atc');
const heroActions = qs('.hero__actions') || qs('.pdp-hero__cart-controls');
if (stickyBar && heroActions) {
  const stickyObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      stickyBar.classList.toggle('visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });
  stickyObserver.observe(heroActions);
}

// =============================================
// PDP — Thumbnail gallery
// =============================================
qsa('.pdp-hero__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const mainImg = document.getElementById('pdp-main-img');
    if (mainImg && thumb.dataset.imgSrc) {
      mainImg.src = thumb.dataset.imgSrc;
      mainImg.alt = thumb.dataset.imgAlt || '';
    }
    qsa('.pdp-hero__thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// =============================================
// PDP — Quantity +/-
// =============================================
qsa('.pdp-hero__qty-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const input = document.getElementById('pdp-qty');
    if (!input) return;
    let val = parseInt(input.value) || 1;
    if (btn.dataset.action === 'increase') val++;
    else if (btn.dataset.action === 'decrease' && val > 1) val--;
    input.value = val;
  });
});

// =============================================
// PDP — Variant pill selection
// =============================================
qsa('.pdp-hero__variant-pill').forEach(pill => {
  pill.addEventListener('click', () => {
    const group = pill.closest('.pdp-hero__variant-group');
    if (group) {
      group.querySelectorAll('.pdp-hero__variant-pill').forEach(p => p.classList.remove('active'));
    }
    pill.classList.add('active');
  });
});

// =============================================
// PDP — Buy Now → direct checkout
// =============================================
const buyNowBtn = document.getElementById('pdp-buy-now');
if (buyNowBtn) {
  buyNowBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const variantId = document.getElementById('pdp-variant-id');
    const qty = document.getElementById('pdp-qty');
    if (variantId && variantId.value) {
      window.location = '/cart/' + variantId.value + ':' + (qty ? qty.value : 1);
    }
  });
}

// =============================================
// PDP — Tabs (desktop)
// =============================================
qsa('.pdp-tabs__tab').forEach(tab => {
  tab.addEventListener('click', () => {
    const panelId = tab.getAttribute('aria-controls');
    const container = tab.closest('.pdp-tabs') || tab.closest('section');
    if (!container) return;
    container.querySelectorAll('.pdp-tabs__tab').forEach(t => {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
    });
    container.querySelectorAll('.pdp-tabs__panel').forEach(p => p.classList.remove('active'));
    tab.classList.add('active');
    tab.setAttribute('aria-selected', 'true');
    const panel = document.getElementById(panelId);
    if (panel) panel.classList.add('active');
    container.querySelectorAll('.pdp-tabs__accordion-trigger').forEach(t => t.classList.remove('active'));
  });
});

// =============================================
// PDP — Accordion (mobile)
// =============================================
qsa('.pdp-tabs__accordion-trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const panelId = trigger.getAttribute('aria-controls');
    const container = trigger.closest('.pdp-tabs') || trigger.closest('section');
    if (!container) return;
    const wasActive = trigger.classList.contains('active');
    container.querySelectorAll('.pdp-tabs__accordion-trigger').forEach(t => {
      t.classList.remove('active');
      t.setAttribute('aria-expanded', 'false');
    });
    container.querySelectorAll('.pdp-tabs__panel').forEach(p => p.classList.remove('active'));
    if (!wasActive) {
      trigger.classList.add('active');
      trigger.setAttribute('aria-expanded', 'true');
      const panel = document.getElementById(panelId);
      if (panel) panel.classList.add('active');
    }
  });
});

// =============================================
// CART DRAWER
// =============================================
const cartDrawer = document.getElementById('cart-drawer');
const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
const cartDrawerClose = document.getElementById('cart-drawer-close');

function openCartDrawer() {
  if (!cartDrawer) return;
  cartDrawer.classList.add('open');
  cartDrawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
}

function closeCartDrawer() {
  if (!cartDrawer) return;
  cartDrawer.classList.remove('open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

/** Sanitize a string for safe HTML insertion */
function escapeHtml(str) {
  var d = document.createElement('div');
  d.textContent = str;
  return d.innerHTML;
}

function formatPrice(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(function(r) {
      if (!r.ok) throw new Error('Cart fetch failed');
      return r.json();
    })
    .then(function(cart) {
      var countEl = document.getElementById('cart-drawer-count');
      var itemsEl = document.getElementById('cart-drawer-items');
      var emptyEl = document.getElementById('cart-drawer-empty');
      var footerEl = document.getElementById('cart-drawer-footer');
      var subtotalEl = document.getElementById('cart-drawer-subtotal');

      if (countEl) countEl.textContent = cart.item_count;
      if (subtotalEl) subtotalEl.textContent = formatPrice(cart.total_price);

      if (cart.item_count === 0) {
        if (itemsEl) itemsEl.style.display = 'none';
        if (emptyEl) emptyEl.style.display = 'flex';
        if (footerEl) footerEl.style.display = 'none';
      } else {
        if (emptyEl) emptyEl.style.display = 'none';
        if (footerEl) footerEl.style.display = 'block';
        if (itemsEl) {
          itemsEl.style.display = 'block';
          itemsEl.innerHTML = cart.items.map(function(item) {
            var imgHtml = item.image
              ? '<img src="' + escapeHtml(item.image.replace(/(\.\w+)$/, '_120x$1')) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
              : '';
            var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
              ? '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>'
              : '';
            // Le coloris est une propriete de ligne, pas une variante : sans
            // ceci, trois consoles de couleurs differentes paraissent identiques.
            if (item.properties) {
              Object.keys(item.properties).forEach(function (cle) {
                var val = item.properties[cle];
                if (!val || cle.charAt(0) === '_') { return; }
                variantHtml += '<div class="cart-drawer__item-variant">'
                  + escapeHtml(cle) + ' : <strong>' + escapeHtml(String(val)) + '</strong></div>';
              });
            }
            return '<div class="cart-drawer__item">'
              + '<div class="cart-drawer__item-img">' + imgHtml + '</div>'
              + '<div class="cart-drawer__item-info">'
              + '<div class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</div>'
              + variantHtml
              + '<div class="cart-drawer__item-bottom">'
              + '<span class="cart-drawer__item-qty">' + (window.theme_translations && window.theme_translations.quantity_short || 'Qté:') + ' ' + item.quantity + '</span>'
              + '<span class="cart-drawer__item-price">' + formatPrice(item.final_line_price) + '</span>'
              + '</div></div></div>';
          }).join('');
        }
      }
    })
    .catch(function(err) {
      console.warn('[Cart] Refresh failed:', err.message);
    });
}

if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')) closeCartDrawer();
});

// =============================================
// ATC FORM — Intercept with loading state + error handling
// =============================================
qsa('form[action="/cart/add"]').forEach(function(form) {
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.classList.contains('is-loading')) return;

    // Loading state
    var originalText = btn.innerHTML;
    btn.classList.add('is-loading');
    btn.disabled = true;
    btn.innerHTML = '<span class="btn-spinner"></span>';

    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function(r) {
        if (!r.ok) throw new Error('Add to cart failed (HTTP ' + r.status + ')');
        return r.json();
      })
      .then(function() {
        // Success — brief check animation then open drawer
        btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
        setTimeout(function() {
          btn.innerHTML = originalText;
          btn.classList.remove('is-loading');
          btn.disabled = false;
          openCartDrawer();
        }, 600);
      })
      .catch(function(err) {
        console.error('[ATC]', err.message);
        btn.innerHTML = originalText;
        btn.classList.remove('is-loading');
        btn.disabled = false;
        // Show inline error
        var errEl = form.querySelector('.atc-error');
        if (!errEl) {
          errEl = document.createElement('div');
          errEl.className = 'atc-error';
          form.appendChild(errEl);
        }
        errEl.textContent = (window.theme_translations && window.theme_translations.error_retry) || 'Une erreur est survenue. Veuillez réessayer.';
        errEl.style.display = 'block';
        setTimeout(function() { errEl.style.display = 'none'; }, 4000);
      });
  });
});

// =============================================
// MENU MOBILE — panneau lateral
// =============================================
(function () {
  var burger = document.getElementById('MenuBurger');
  var menu = document.getElementById('MobileMenu');
  if (!burger || !menu) return;

  var panel = menu.querySelector('.mobile-menu__panel');
  var closeBtn = menu.querySelector('.mobile-menu__close');
  var lastScroll = 0;

  function openMenu() {
    lastScroll = window.scrollY;
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Fermer le menu');
    document.body.classList.add('menu-open');
    if (closeBtn) { setTimeout(function () { closeBtn.focus(); }, 320); }
  }

  function closeMenu(refocus) {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Ouvrir le menu');
    document.body.classList.remove('menu-open');
    if (refocus) { burger.focus(); }
  }

  burger.addEventListener('click', function () {
    if (menu.classList.contains('is-open')) { closeMenu(true); } else { openMenu(); }
  });

  // Fermeture : croix, fond sombre
  menu.querySelectorAll('[data-menu-close]').forEach(function (el) {
    el.addEventListener('click', function () { closeMenu(true); });
  });

  // Fermeture : clic sur un lien (utile quand la cible est sur la meme page)
  menu.querySelectorAll('a[href]').forEach(function (link) {
    link.addEventListener('click', function () { closeMenu(false); });
  });

  // Fermeture : touche Echap
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) { closeMenu(true); }
  });

  // Le focus reste dans le panneau tant qu'il est ouvert
  document.addEventListener('focusin', function (e) {
    if (!menu.classList.contains('is-open')) return;
    if (panel && !panel.contains(e.target) && e.target !== burger) {
      var first = panel.querySelector('a[href], button');
      if (first) first.focus();
    }
  });

  // Retour en grand ecran : on referme pour eviter un panneau fantome
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (window.innerWidth > 768 && menu.classList.contains('is-open')) { closeMenu(false); }
    }, 150);
  });
})();

// =============================================
// HERO — Coloris (blocs du theme) + quantite
// =============================================
(function () {
  // ── Coloris : change la grande image et la couleur envoyee avec la commande
  var boutons = document.querySelectorAll('.js-hero-color');
  if (boutons.length) {
    var image = document.getElementById('hero-main-img');
    var nomAffiche = document.getElementById('hero-color-name');
    var champCouleur = document.getElementById('hero-color-prop');

    boutons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        boutons.forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');

        var nom = btn.dataset.colorName || '';
        if (nomAffiche) nomAffiche.textContent = nom;
        if (champCouleur) champCouleur.value = nom;

        var src = btn.dataset.colorImage;
        if (image && src) {
          // on precharge : evite le clignotement blanc pendant le telechargement
          var tampon = new Image();
          tampon.onload = function () {
            image.src = src;
            image.removeAttribute('srcset');
            image.alt = nom;
          };
          tampon.src = src;
        }
      });
    });
  }

  // ── Quantite
  var champQte = document.getElementById('hero-qty');
  document.querySelectorAll('.js-hero-qty').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!champQte) return;
      var v = parseInt(champQte.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (btn.dataset.action === 'increase') { v = Math.min(99, v + 1); }
      else if (v > 1) { v = v - 1; }
      champQte.value = v;
    });
  });
  if (champQte) {
    champQte.addEventListener('change', function () {
      var v = parseInt(champQte.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > 99) v = 99;
      champQte.value = v;
    });
  }
})();
